import { v4 as uuidv4 } from "uuid";

export const getSessionId = () => {
  const sessionIdKey = "sessionId";
  const storedSessionId = sessionStorage.getItem(sessionIdKey);
  const sessionId = storedSessionId || uuidv4();
  sessionStorage.setItem(sessionIdKey, sessionId);
};
